// Angular Core
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

// RxJS
import { Observable } from 'rxjs';

// Interfaces
import { UserCredentials, UserData } from '../../interfaces/User';
import { SuccessResponse } from '../../interfaces/Success';
import { TokenConfigs } from '../../interfaces/TokenConfigs';

// Environment
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  apiUrl: string = environment.apiUrl

  // Dependency Injections
  private httpClient: HttpClient = inject(HttpClient)

  authenticate(loginInfo: UserCredentials): Observable<TokenConfigs> {
    return this.httpClient.post<TokenConfigs>(`${this.apiUrl}/auth/login`, loginInfo);
  }

  getUserData(): Observable<UserData> {
    return this.httpClient.post<UserData>(`${this.apiUrl}/auth/me`, {});
  }

  logout(): Observable<SuccessResponse> {
    return this.httpClient.post<SuccessResponse>(`${this.apiUrl}/auth/logout`, {});
  }

  forgotPassword(email: string): Observable<SuccessResponse> {
    return this.httpClient.post<SuccessResponse>(`${this.apiUrl}/password/forgot`, { email });
  }

  resetPassword(password: string, resetPasswordToken: string): Observable<SuccessResponse> {
    return this.httpClient.post<SuccessResponse>(`${this.apiUrl}/password/reset/${resetPasswordToken}`, { password });
  }

  setRememberMe(email: string, password: string): void {
    let localStorageUsersCredentials = localStorage.getItem('saved-users')

    let savedUsersCredentials: UserCredentials[] = localStorageUsersCredentials ? JSON.parse(localStorageUsersCredentials) : []

    let user: UserCredentials = { email, password }

    let userAlreadyExists: UserCredentials | undefined = savedUsersCredentials.find((savedUser: UserCredentials) => savedUser.email === user.email)
    if(!userAlreadyExists) {
      savedUsersCredentials.push(user)
    } else {
      savedUsersCredentials = savedUsersCredentials.filter((user: UserCredentials) => user.email !== userAlreadyExists.email)

      savedUsersCredentials.push(user)
    }

    localStorage.setItem('saved-users', JSON.stringify(savedUsersCredentials))
  }
}
